import PropTypes from 'prop-types';

export const travelAgency = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  tagline: PropTypes.string,
  image: PropTypes.string,
};

export const tour = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  tagline: PropTypes.string,
  image: PropTypes.string,
  start: PropTypes.string,
  end: PropTypes.string,
  travel_agency: PropTypes.shape(travelAgency).isRequired,
};
export const note = {
  id: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  created_on: PropTypes.string,
};
export const bidType = {
  id: PropTypes.number.isRequired,
  hotel: PropTypes.string.isRequired,
  start: PropTypes.string,
  end: PropTypes.string,
  suites: PropTypes.number,
  kings: PropTypes.number,
  queens: PropTypes.number,
  suite_rate: PropTypes.number,
  kings_rate: PropTypes.number,
  queens_rate: PropTypes.number,
  notes: PropTypes.arrayOf(PropTypes.shape(note)),
};

export const commissionType = {
  id: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  due: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  tour: PropTypes.shape(tour).isRequired,
  bid: PropTypes.shape(bidType).isRequired,
};



// WEBPACK FOOTER //
// src/routes/commissions/components/CommissionPropTypes.js